import { useEffect, useState } from "react";
import api from "@/lib/api";
import { History, User } from "lucide-react";

const ACTION_COLOR = {
  "stok güncelledi": "#10B981",
  "malzeme ekledi": "#2563EB",
  "malzeme sildi": "#EF4444",
  "malzeme düzenledi": "#0EA5E9",
  "üretim siparişi ekledi": "#8B5CF6",
  "üretim siparişi sildi": "#EF4444",
  "satın alma siparişi oluşturdu": "#F59E0B",
  "satın alma siparişi düzenledi": "#0EA5E9",
  "satın alma siparişi kapattı": "#64748B",
  "teslimat kaydetti": "#10B981",
  "satın alma siparişi sildi": "#EF4444",
  "gelen malzeme düzenledi": "#0EA5E9",
  "gelen malzeme sildi": "#EF4444",
  "reçete içe aktardı": "#EC4899",
  "reçete düzenledi": "#0EA5E9",
  "reçete sildi": "#EF4444",
  "kullanıcı kaydı": "#64748B",
};

function timeAgo(iso) {
  const d = new Date(iso);
  return d.toLocaleString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
}

export default function Activity() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get("/activity?limit=200").then((r) => { setRows(r.data); setLoading(false); }).catch(() => { setError(true); setLoading(false); });
  }, []);

  return (
    <div className="space-y-6 animate-in-up" data-testid="activity-page">
      <div>
        <h1 className="font-head text-3xl font-bold tracking-tight">Geçmiş Hareketler</h1>
        <p className="text-[#94A3B8] text-sm mt-1">Sistemde yapılan tüm değişiklikler ve yapan kullanıcı</p>
      </div>

      {loading && <div className="text-[#94A3B8] text-sm">Yükleniyor...</div>}
      {error && <div className="text-[#EF4444] text-sm">Geçmiş hareketler yüklenemedi. Lütfen sayfayı yenileyin.</div>}

      <div className="bg-[#131A26] border border-[#212D40] rounded-xl overflow-hidden">
        <div className="overflow-x-auto">
        <table className="w-full text-sm min-w-[560px]" data-testid="activity-table">
          <thead>
            <tr className="text-left text-[#94A3B8] text-xs uppercase tracking-wider border-b border-[#212D40] bg-[#0F1520]">
              <th className="py-3 px-5">Kullanıcı</th>
              <th className="py-3 px-5">İşlem</th>
              <th className="py-3 px-5">Detay</th>
              <th className="py-3 px-5">Tarih / Saat</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((a) => (
              <tr key={a.id} className="border-b border-[#1a2334] hover:bg-[#0F1520]" data-testid={`activity-row-${a.id}`}>
                <td className="py-3 px-5">
                  <span className="flex items-center gap-2 font-medium">
                    <span className="w-7 h-7 rounded-full bg-[#0F1520] border border-[#212D40] flex items-center justify-center">
                      <User className="w-3.5 h-3.5 text-[#94A3B8]" />
                    </span>
                    {a.user_name}
                  </span>
                </td>
                <td className="py-3 px-5">
                  <span className="text-xs font-semibold px-2.5 py-1 rounded-full"
                    style={{ color: ACTION_COLOR[a.action] || "#94A3B8", background: `${ACTION_COLOR[a.action] || "#94A3B8"}22` }}>
                    {a.action}
                  </span>
                </td>
                <td className="py-3 px-5 text-[#cbd5e1]">{a.detail}</td>
                <td className="py-3 px-5 font-num text-[#94A3B8] whitespace-nowrap">{timeAgo(a.timestamp)}</td>
              </tr>
            ))}
            {!loading && rows.length === 0 && (
              <tr><td colSpan={4} className="py-10 text-center text-[#64748B]">
                <History className="w-8 h-8 mx-auto mb-2 opacity-50" /> Henüz hareket yok.
              </td></tr>
            )}
          </tbody>
        </table>
        </div>
      </div>
    </div>
  );
}
